import {
  Box,
  KdsCardFile,
  KdsDivider,
  KdsLink,
  KdsText,
  VStack,
} from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { useState } from "react";
import { download } from "@/helpers/download";
import { useFile } from "@/hooks";
import { type ExpressionOfNeedProps } from "./ExpressionOfNeed.types";

export const ExpressionOfNeed = ({
  description,
  files,
  isDefaultCollapsed = false,
  isWithMediaOnly = false,
}: ExpressionOfNeedProps) => {
  const { t } = useTranslate();

  const [isCollapsed, setIsCollapsed] = useState(!isDefaultCollapsed);

  const { useDownloadFile } = useFile();
  const { mutateAsync: downloadFileMutation } = useDownloadFile();

  const downloadDocument = async (url: string, filename: string) => {
    const b64string = await downloadFileMutation({ url });
    download(b64string, filename);
  };

  return (
    <Box p="sp-md" bgColor="elevation.second" rounded="br-xs" w="100%">
      <VStack gap="sp-xs">
        {!isWithMediaOnly && (
          <div className={isCollapsed ? "line-clamp-2" : undefined}>
            <KdsText size="subtitle-sm">{description}</KdsText>
          </div>
        )}

        {!isWithMediaOnly && !isCollapsed && !!files?.length && <KdsDivider />}

        {(!isCollapsed || isWithMediaOnly) &&
          files?.map((file, index) => {
            if (isCollapsed && index > 0) {
              return null;
            }

            return (
              <KdsCardFile
                key={file.blobId}
                fileName={file.name}
                fileUrl={file.url}
                fileSize={file.size}
                isDownloadable
                onDownload={() =>
                  void downloadDocument(file.url || "", file.name || "")
                }
                isViewable
              />
            );
          })}

        {!!files && !!files.length && (
          <KdsLink
            size="sm"
            state="neutral"
            href="#"
            onPress={() => setIsCollapsed(!isCollapsed)}
          >
            {isCollapsed
              ? t("expertMode.qualifyDrawer.expressionOfNeed.expand")
              : t("expertMode.qualifyDrawer.expressionOfNeed.collapse")}
          </KdsLink>
        )}
      </VStack>
    </Box>
  );
};
